/**
 * Saltbox — cart drawer, variant picker, predictive search, gallery.
 *
 * No framework and no build step. Everything here is an enhancement over
 * markup that already works: the cart icon is a link to /cart, the variant
 * inputs are a real form, and search is a GET form to /search. If this file
 * fails to load the shop still sells things.
 */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var announce = function (msg) {
    var live = document.getElementById('a11y-live');
    if (live) { live.textContent = msg; }
  };

  /* ================================================================
   * Cart drawer
   * ============================================================== */
  var drawer = $('[data-cart-drawer]');
  var scrim  = $('[data-cart-scrim]');
  var lastFocus = null;

  function openCart() {
    if (!drawer) { return; }
    lastFocus = document.activeElement;
    scrim.hidden = false;
    window.requestAnimationFrame(function () {
      scrim.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = $('[data-cart-close]', drawer);
    if (close) { close.focus(); }
  }

  function closeCart() {
    if (!drawer) { return; }
    scrim.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.setTimeout(function () { scrim.hidden = true; }, 300);
    if (lastFocus) { lastFocus.focus(); }
  }

  /* Re-fetches the cart drawer markup from the section rendering API, so the
     drawer always shows what Shopify thinks is in the cart rather than what
     this script guessed. */
  function refreshCart() {
    return fetch(window.routes.cart_url + '?view=drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var items = $('[data-cart-items]', doc);
        if (items && $('[data-cart-items]')) {
          $('[data-cart-items]').innerHTML = items.innerHTML;
        }

        var count = $('[data-cart-count]', doc);
        if (count) {
          $$('[data-cart-count]').forEach(function (el) { el.textContent = count.textContent; });
        }

        var total = $('[data-cart-total]', doc);
        if (total && $('[data-cart-total]')) {
          $('[data-cart-total]').textContent = total.textContent;
        }
      })
      .catch(function () { /* Leave the drawer as-is; the cart page is still correct. */ });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      /* Only hijack the link when the drawer is switched on; otherwise let it
         navigate to the cart page, which is what the merchant chose. */
      if (drawer && document.body.dataset.cartDrawer !== 'off') {
        e.preventDefault();
        openCart();
      }
      return;
    }
    if (e.target.closest('[data-cart-close]') || e.target === scrim) { closeCart(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) { closeCart(); }
  });

  /* Focus stays inside the drawer while it is open. */
  if (drawer) {
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') { return; }
      var f = $$('a[href],button:not([disabled]),input:not([disabled]),textarea,select', drawer);
      if (!f.length) { return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ================================================================
   * Add to cart, without leaving the page
   * ============================================================== */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !drawer) { return; }

    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var label  = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = '…'; }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          /* Shopify returns a status field only on errors — out of stock, for
             instance. Fall back to a normal submit so the customer sees the
             real message rather than nothing happening. */
          form.submit();
          return;
        }
        return refreshCart().then(function () {
          openCart();
          announce(window.saltboxStrings.addToCart);
        });
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = label; }
      });
  });

  /* ================================================================
   * Variant picker
   * ============================================================== */
  $$('variant-picker').forEach(function (picker) {
    var dataEl = $('[data-variant-data]', picker);
    if (!dataEl) { return; }

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = $('#ProductForm') || $('form[action*="/cart/add"]');
    if (!form) { return; }

    var idInput = $('[data-variant-id]', form);
    var button  = $('[data-add-button]', form);
    var priceEl = $('.product-price');

    picker.addEventListener('change', function () {
      var chosen = $$('input:checked', picker).map(function (i) { return i.value; });

      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });

      if (!match) {
        if (button) {
          button.disabled = true;
          button.textContent = window.saltboxStrings.unavailable;
        }
        return;
      }

      if (idInput) { idInput.value = match.id; }

      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available
          ? window.saltboxStrings.addToCart
          : window.saltboxStrings.soldOut;
      }

      /* Keep the URL in step so a copied link lands on the same variant. */
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      if (priceEl && match.price !== undefined) {
        var item = $('.price-item', priceEl);
        if (item && window.Shopify && window.Shopify.formatMoney) {
          item.textContent = window.Shopify.formatMoney(match.price);
        }
      }

      /* Swap the gallery to the variant's own image, if it has one. */
      if (match.featured_media && match.featured_media.preview_image) {
        var main = $('#GalleryMain');
        if (main) { main.src = match.featured_media.preview_image.src; }
      }
    });
  });

  /* ================================================================
   * Product gallery thumbnails
   * ============================================================== */
  $$('.gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = $('#GalleryMain');
      if (!main) { return; }
      main.src = thumb.dataset.full;
      main.removeAttribute('srcset');
      $$('.gallery-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ================================================================
   * Predictive search
   * ============================================================== */
  var panel = $('[data-search-panel]');
  var input = $('[data-search-input]');
  var results = $('[data-search-results]');

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) {
      if (!panel) { return; }
      panel.hidden = !panel.hidden;
      if (!panel.hidden && input) { input.focus(); }
    }
    if (e.target.closest('[data-search-close]') && panel) { panel.hidden = true; }
  });

  if (input && results) {
    var timer = null;

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var q = input.value.trim();

      if (q.length < 2) { results.innerHTML = ''; return; }

      /* Debounced: one request when they stop typing, not one per keystroke. */
      timer = window.setTimeout(function () {
        var url = window.routes.predictive_search_url +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&section_id=predictive-search';

        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var list = doc.querySelector('[data-search-results]');
            results.innerHTML = list ? list.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 250);
    });
  }

  /* ================================================================
   * Mobile menu
   * ============================================================== */
  var toggle = $('.menu-toggle');
  var mobile = $('#MobileNav');

  if (toggle && mobile) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mobile.hidden = open;
    });
  }
})();
